<template>
  <div class="preview-table">
    <base-list-management ref="baseListRef" :configData="configData" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { previewTableConfig } from '../config/previewTable'

const props = defineProps({
  apiFn: {
    type: Function,
    required: true,
  },
})

const baseListRef = ref(null)

// 使用独立的响应式状态管理展开/收起状态
// Vue 2 中 reactive({}) 动态添加属性有响应式问题，改用 ref({}) 并整体替换对象
const plansExpandedMap = ref({})
const storesExpandedMap = ref({})

// 生成行的唯一标识
const getRowKey = (row) => {
  return row.productId
}

// 获取展开状态
const getExpandState = (row, type) => {
  const key = getRowKey(row)
  if (type === 'plansExpanded') {
    return plansExpandedMap.value[key] || false
  }
  if (type === 'storesExpanded') {
    return storesExpandedMap.value[key] || false
  }
  return false
}

// 展开/收起租赁方案
const togglePlansExpand = (row) => {
  const key = getRowKey(row)
  // 整体替换对象以触发响应式更新
  plansExpandedMap.value = {
    ...plansExpandedMap.value,
    [key]: !plansExpandedMap.value[key],
  }
}

// 展开/收起门店
const toggleStoresExpand = (row) => {
  const key = getRowKey(row)
  // 整体替换对象以触发响应式更新
  storesExpandedMap.value = {
    ...storesExpandedMap.value,
    [key]: !storesExpandedMap.value[key],
  }
}

// 配置数据（使用 ref 而不是 computed）
const configData = ref(
  previewTableConfig({
    togglePlansExpand,
    toggleStoresExpand,
    getExpandState,
    apiFn: props.apiFn,
  }),
)

// 刷新
const refresh = () => {
  baseListRef.value?.refresh?.()
}

// 暴露方法
defineExpose({
  refresh,
})
</script>

<style lang="scss" scoped>
.preview-table {
  ::v-deep .product-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .product-name {
      color: #303133;
    }

    .el-tag {
      width: fit-content;
    }
  }

  ::v-deep .plans-cell,
  ::v-deep .stores-cell {
    .plan-item,
    .store-item {
      color: #606266;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-link {
      font-size: 13px;
    }
  }
}
</style>
